import api from './api';
import { Vital, VitalDto } from '../types/vitals';

export class VitalsService {
  static async getVitals(memberId: string): Promise<Vital | null> {
    const response = await api.get(`/vitals/${memberId}`);
    return response.data;
  }

  static async createVitals(memberId: string, dto: VitalDto): Promise<Vital> {
    const response = await api.post(`/vitals/${memberId}`, dto);
    return response.data;
  }
}

export default VitalsService;
